import { jsx } from "react/jsx-runtime";
import cx from "classnames";
const AspectRatioBox = (props) => {
  const {
    tagType = "span",
    prefix = "",
    className,
    ratio = "standard",
    children,
    ...others
  } = props;
  const classes = cx(
    `${prefix}aspect-ratio-box`,
    ratio && `${prefix}aspect-ratio-box--${ratio.replace(/:/g, "-")}`,
    className
  );
  const SpanOrDiv = tagType;
  return /* @__PURE__ */ jsx(SpanOrDiv, { className: `${classes}`, ...others, children });
};
var AspectRatioBox_default = AspectRatioBox;
export {
  AspectRatioBox_default as default
};
